import React from 'react';
import { Button } from '@material-ui/core';
import TaskuriList from './TaskuriList'
import FromServer from '../module/projects/FromServer';
import Utils from '../providers/Utils';
import PropTypes from 'prop-types'

export default class EtapeListBeta extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
                myData :{}
}
    }

     componentDidMount(){
    }


  

    filterTaskuri = () =>{

        let filterTaskuri = this.props.listTaskuri.filter(t => t.id_etapa_proiect === this.props.etapa.id)

        filterTaskuri = filterTaskuri.filter(t => t.id_task_parent === null)

        return (
            <TaskuriList 
            listTaskuri={filterTaskuri}
            listSubtaskuri ={this.props.listSubTaskuri}
            dict={this.props.dict}
            taskDrag={this.props.dragStart}
            dragEndTask={this.props.dragEndTask}
            onTaskClick={this.props.getTaskData}
            etapaInfo={this.props.etapa}
            />
        )
    }

    showData = (d)=>{

        let u = new Utils()
        if(this.props.dict.data ==='en'){
            return u.dataPrescurtataEng(d)

        }else{
            return u.dataPrescurtataRomana(d)
        }
    }



     render() { 
       return (
          <div  className={this.props.titlu ? 'pm-etapa-list' : 'pm-etapa-list-add'}>
              {this.props.titlu && 
              <div onDragOver={(ev)=>{this.props.dragOverEt(ev)}} onDrop={()=>{this.props.dropEt(this.props.etapa)}} style={{position:'relative', height:'100%'}}>
               <h3 style={{marginBottom:5}} className="pm-task-title">{this.props.titlu}</h3>
               <h5 style={{marginTop:0}} className="pm-task-title">{ this.showData(this.props.etapa.durata_de_la) + ' - ' + this.showData(this.props.etapa.durata_pana_la)}</h5>
               <div className='pm-etape-change-container'>
                   <i className="material-icons pm-etape-change-hover">more_vert</i>
                   <i onClick={()=>{this.props.deleteEtapa(this.props.etapa)}} className="material-icons pm-etape-change-delete">delete</i>
                   <i onClick={()=>{this.props.editEtapa(this.props.etapa)}} className="material-icons pm-etape-change-edit">edit</i>
                   
               </div>

               {this.filterTaskuri()}
               <div className='pm-task-add-button'>  <Button style={{justifyContent: 'left'}} className='pm-task-buttons' onClick={()=>{this.props.addNewTask(this.props.etapa)}}>
                        <i className='material-icons'>add</i> 
                    
                            <span className='pm-appbar-button-text'>
                            {this.props.dict.proiecte.etapeProiect.addTask} 
                                </span> 
                    
                        
                            
                        </Button >
                        </div>
            </div> 
            }
            
            
            { !this.props.titlu && 
            
          
    
            <Button style={{justifyContent: 'left', width:'fit-content'}} className='pm-appbar-buttons' onClick={this.props.addNewEtapa}>
                        <i className='material-icons'>add</i> 
                    
                            <span className='pm-appbar-button-text'>
                            {this.props.dict.proiecte.etapeProiect.addEtapa} 
                                </span> 
                    
                        
                            
                        </Button >
            }






           
         </div>
        );
       }
}


//end class


EtapeListBeta.propType ={
    listTaskuri:PropTypes.array,
    etapa:PropTypes.object,
    listSubTaskuri:PropTypes.array,
    dict:PropTypes.object,
    dragStart:PropTypes.func,
    dragEndTask:PropTypes.func,
    getTaskData:PropTypes.func,
    titlu:PropTypes.string,
    dragOverEt:PropTypes.func,
    dropEt:PropTypes.func,
    deleteEtapa:PropTypes.func,
    editEtapa:PropTypes.func,
    addNewTask:PropTypes.func,
    addNewEtapa:PropTypes.func

}